import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { DataTablesModule } from 'angular-datatables';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseChartDirective } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../../../shared/shared.module';
import { EnitComplainceRoutingModule } from '../eComplaince-routing.module';
import { CtclModule } from '../EnitTrade/ctcl/ctcl.module';
import { EnitRoutingModule } from '../eTrade-routing.module';
import { TradeAdminRoutingModule } from '../tradeAdmin-routing.module';
import { AddAIMLEligibleTradeUserComponent } from './add-aimleligible-trade-user/add-aimleligible-trade-user.component';
import { AddCyberSecurityEnableUsersComponent } from './add-cyber-security-enable-users/add-cyber-security-enable-users.component';
import { AddHalfYearlyNetworthEligibleUserComponent } from './add-half-yearly-networth-eligible-user/add-half-yearly-networth-eligible-user.component';
import { AdminCyberSecurityReportComponent } from './admin-cyber-security-report/admin-cyber-security-report.component';
import { AdvertisementAdminComponent } from './advertisement-admin/advertisement-admin.component';
import { AdvertisementPreviewComponent } from './advertisement-preview/advertisement-preview.component';
import { AdvertisementRequestComponent } from './advertisement-request/advertisement-request.component';
import { AIMLEligibleUserComponent } from './aimleligible-user/aimleligible-user.component';
import { AnnualReturnModule } from './Annual Returns/annual-return.module';
import { AnnualAuditAdminModule } from './annual-compliance-audit/annual-audit-admin.module';
import { AnnualAuditModule } from './annual-compliance-audit/member/annual-audit-member.module';
import { AuthorisedPersonAdminModule } from './authorised-person/admin/authorised-person-admin.module';
import { AuthorisedPersonModule } from './authorised-person/authorised-person.module';
import { AuthorisePersonMemberModule } from './authorised-person/member/authorised-person-member.module';
import { BmcDashboardComponent } from './bmc/bmc-dashboard/bmc-dashboard.component';
import { ChangeInRegModule } from './Change in registered address/change-in-reg.module';
import { ChangeInClearingMemberModule } from './change-in-clearing-member/changeinclearingmem.module';
import { ComplianceDashboardComponent } from './compliance-dashboard/compliance-dashboard.component';
import { CyberSecurityAdminListComponent } from './cyber-security-admin-list/cyber-security-admin-list.component';
import { CyberSecurityEnableUsersComponent } from './cyber-security-enable-users/cyber-security-enable-users.component';
import { CyberSecurityMemberListComponent } from './cyber-security-member-list/cyber-security-member-list.component';
import { CyberSecurityMemberreportUploadComponent } from './cyber-security-memberreport-upload/cyber-security-memberreport-upload.component';
import { CyberAuditModule } from './CyberAudit/cyber-audit.module';
import { CyberSecurityAuditModule } from './CyberSecurityAudit/cyber-security-audit.module';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { EnitComplianceAdminComponent } from './enit-compliance-admin/enit-compliance-admin.component';
import { HalfYearlyElibileHistoryComponent } from './half-yearly-elibile-history/half-yearly-elibile-history.component';
import { HalfYearlyFormSubmissionHistoryMemberComponent } from './half-yearly-form-submission-history-member/half-yearly-form-submission-history-member.component';
import { HalfYearlyNetworthConfigComponent } from './half-yearly-networth-config/half-yearly-networth-config.component';
import { HalfYearlyNetworthEligibleUserComponent } from './half-yearly-networth-eligible-user/half-yearly-networth-eligible-user.component';
import { HalfYearlyModule } from './half-yearly/half-yearly.module';
import { InternalAuditModule } from './InternalAudit/internal-audit.module';
import { IssuanceModule } from './Issuance of report/issuance.module';
import { MlAiModalComponent } from './ml-ai-modal/ml-ai-modal.component';
import { MlAiRequestComponent } from './ml-ai-request/ml-ai-request.component';
import { MlAndAiComponentAdminListComponent } from './ml-and-ai-component-admin-list/ml-and-ai-component-admin-list.component';
import { MlAndAiComponentListComponent } from './ml-and-ai-component-list/ml-and-ai-component-list.component';
import { MonitoringClientFundAdmin } from './monitoring-client-funds/admin/monitoring-client-funds-admin.module';
import { MonitoringClientFundMember } from './monitoring-client-funds/member/monitoring-client-funds-member.module';
import { PenaltyCalculation } from './PenaltyCalculation/penalty-calculation.module';
import { PressNoteModule } from './Press Note 3/press-note.module';
import { QuaterlyIncidentReportComponent } from './quaterly-incident-report/quaterly-incident-report.component';
import { SezLoaDetailsModule } from './SezLoaDetails/sez-loa-details.module';
import { SlaModuleDataComponent } from './sla-module-data/sla-module-data.component';
import { SlaSetupComponent } from './sla-setup/sla-setup.component';
import { SurrenderSubmissionAdminModule } from './Surrender Submission/Admin/surrender-submission-admin.module';
import { SurrenderSubmissionMemberModule } from './Surrender Submission/Member/surrender-submission-member.module';
import { ChangeComplianceOfficerModule } from './ChangeInComplianceOfficer/change-compliance-officer.module';
import { IfscaCmiReportModule } from './ifsca-cmi-reporting/ifsca-cmi-report.module';
import { IcsiCmiCertificationModule } from './icsi-cmi-certification/icsi-cmi-certification.module';

import { AnnualComplianceAuditReportModule } from './AnnualComplianceAuditReport/annual-compliance-audit-report.module';

@NgModule({
  declarations: [
    AddAIMLEligibleTradeUserComponent,
    AddCyberSecurityEnableUsersComponent,
    AddHalfYearlyNetworthEligibleUserComponent,
    AdminCyberSecurityReportComponent,
    AdvertisementAdminComponent,
    AdvertisementPreviewComponent,
    AdvertisementRequestComponent,
    AIMLEligibleUserComponent,
    BmcDashboardComponent,
    ComplianceDashboardComponent,
    CyberSecurityAdminListComponent,
    CyberSecurityEnableUsersComponent,
    CyberSecurityMemberListComponent,
    CyberSecurityMemberreportUploadComponent,
    EmailTemplateComponent,
    EnitComplianceAdminComponent,
    HalfYearlyElibileHistoryComponent,
    HalfYearlyFormSubmissionHistoryMemberComponent,
    HalfYearlyNetworthConfigComponent,
    HalfYearlyNetworthEligibleUserComponent,
    MlAiModalComponent,
    MlAiRequestComponent,
    MlAndAiComponentAdminListComponent,
    MlAndAiComponentListComponent,
    QuaterlyIncidentReportComponent,
    SlaModuleDataComponent,
    SlaSetupComponent
  ],
  imports: [
    
    CommonModule,
    EnitRoutingModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    HalfYearlyModule,
    AnnualReturnModule,
    AnnualAuditModule,
    ChangeInClearingMemberModule,
    ChangeComplianceOfficerModule,
    CtclModule,
    EnitComplainceRoutingModule,
    ChangeInRegModule,
    PenaltyCalculation,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule,
    SurrenderSubmissionMemberModule,
    AnnualAuditAdminModule,
    InternalAuditModule,
    SurrenderSubmissionAdminModule,
    IssuanceModule,
    AuthorisedPersonAdminModule,
    AuthorisePersonMemberModule,
    AuthorisedPersonModule,
    PressNoteModule,
    CyberAuditModule,
    MonitoringClientFundAdmin,
    MonitoringClientFundMember,
    SezLoaDetailsModule,
    CyberSecurityAuditModule,
    IfscaCmiReportModule,
    IcsiCmiCertificationModule,
    AnnualComplianceAuditReportModule,
  ]
})
export class EnitComplainceModule { }
